@if (data) {
    <div class="partial-status-display-tooltip">
        <div class="tooltip-header">
            <h3>{{ 'exports.imports-monitoring.drilldownStatus.partialSuccess.header' | translate }}</h3>
            <div class="summary-stats">
                <span class="stat success">{{ successCount() }} ✓</span>
                <span class="stat error">{{ errorCount() }} ✗</span>
            </div>
        </div>
        <div class="compact-status-list">
            @for (section of processedData(); track section.featureGroupId) {
                <div class="status-row" [class.has-errors]="!section.isSuccessful">
                    <div class="status-main">
                        <span class="section-name">{{ section.featureGroupName }}</span>
                        <div class="status-icon" [class.success]="section.isSuccessful" [class.error]="!section.isSuccessful">
                            @if (section.isSuccessful) {
                                <i class="fas fa-check"></i>
                            } @else {
                                <i class="fas fa-xmark"></i>
                            }
                        </div>
                    </div>
                    @if (section.children.length > 0 && !section.isSuccessful) {
                        <div class="error-details">
                            @for (item of section.failedChildren; track item.id) {
                                <span class="error-item">{{ item.name }}</span>
                            }
                            @if (section.extraFailedChildren && section.extraFailedChildren > 0) {
                                <span class="more-items">{{
                                    'exports.imports-monitoring.drilldownStatus.partialSuccess.andMoreItems'
                                        | translate: { numberOfItems: section.extraFailedChildren }
                                }}</span>
                            }
                        </div>
                    }
                </div>
            }
        </div>
    </div>
}
